import React from 'react';
import { Link } from "gatsby";
import { makeStyles, } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    "&:hover": {
      color: "#b60011",   
    }
  },
}));

const BlockWindDataMap = (props) => {
  const hoverStyle = useStyles();
  return (
    <React.Fragment>
      <Link className={hoverStyle.root} to="/windandwave">
      <h2 style={{fontSize:"18px", fontWeight:"600"}}>Wind and wave map</h2>
      <div id="windDesktop">
        <img src={`${process.env.MET_WINDANDWAVE}/Wind%20Waves%202018%2049.png`} alt="" />
      </div>
      </Link>
    </React.Fragment>
  )
}

export default BlockWindDataMap;